import { render, staticRenderFns } from "./FrsUnitPicker.vue?vue&type=template&id=2fb8af75&scoped=true&"
import script from "./FrsUnitPicker.vue?vue&type=script&lang=js&"
export * from "./FrsUnitPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb8af75",
  null
  
)

export default component.exports